import { useOrganizationInvitationReject } from "@/api";
import { Button } from "@/components/ui/button";
import { LoadingCircle } from "@/components/ui/loadingCircle";
import { toast } from "@/components/ui/use-toast";
import { useNavigate, useSearch } from "@tanstack/react-router";

interface Props {
  invitationId: string;
}

export function RejectInvitation({ invitationId }: Props) {
  const navigate = useNavigate();
  const [rejectInvitation, { loading }] = useOrganizationInvitationReject();
  const { redirect } = useSearch({ from: "/_auth/invitation/$invitationId" });

  return (
    <div className="flex items-center gap-2 relative">
      <Button
        variant="outline"
        disabled={loading}
        onClick={() => {
          rejectInvitation({ variables: { invitationId } })
            .then((res) => {
              if (
                res.data?.organizationInvitationReject?.__typename ===
                "OrganizationInvitationRejected"
              ) {
                toast({
                  title: "Organization invitation rejected"
                });

                if (redirect) navigate(redirect);
                else
                  navigate({
                    to: "/organization"
                  });
              } else {
                toast({
                  title: "Unable to reject organization invitation",
                  description:
                    "An error occurred while rejecting the invitation. Please try again or report the problem.",
                  variant: "destructive"
                });
              }
            })
            .catch((error) => {
              console.error("Reject organization invitation error: ", error);
              toast({
                title: "Unable to reject organization invitation",
                description:
                  "An error occurred while rejecting the invitation. Please try again or report the problem.",
                variant: "destructive"
              });
            });
        }}
      >
        Reject
      </Button>
      {loading && <LoadingCircle className="absolute -right-7" />}
    </div>
  );
}
